<template>
  <div class="ws-chip" :class="clz">
    {{ value }}
  </div>
</template>
<script>
export default {
  name:'WsChip', // a simple and fast chip component
  props: {
    value:String,
    isDisabled:{type:Boolean,default:false},
  },
  computed: {
    clz() {
      return this.isDisabled ? 'ws-chip-disabled' : 'primary';
    },
  },
}
</script>
<style scoped>
.ws-chip {
  position:relative;
  color: white;
  border-radius: 1.5em;
  padding: 4px 4px;
  height: 2em !important;
  text-align: center;
  display:flex;
  align-items: center;
  justify-content: center;
  white-space: wrap;
  font-size: 0.8em !important;
}
.theme--light .ws-chip-disabled{
  background:#b0b0b0
}
.theme--dark .ws-chip-disabled{
  background: #565f67
}

</style>